var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusLastStepActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 32,
    viewBox: "0 0 133 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_959_2692",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2623 6.54771C-0.8927 3.93934 0.962566 0 4.346 0H129C131.209 0 133 1.79086 133 4V28C133 30.2091 131.209 32 129 32H4.34601C0.962578 32 -0.892696 28.0607 1.2623 25.4523L6.96678 18.5477C8.18852 17.0689 8.18852 14.9311 6.96678 13.4523L1.2623 6.54771Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2623 6.54771C-0.8927 3.93934 0.962566 0 4.346 0H129C131.209 0 133 1.79086 133 4V28C133 30.2091 131.209 32 129 32H4.34601C0.962578 32 -0.892696 28.0607 1.2623 25.4523L6.96678 18.5477C8.18852 17.0689 8.18852 14.9311 6.96678 13.4523L1.2623 6.54771Z",
    fill: "#31808F",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96678 18.5477L6.19586 17.9108L6.19586 17.9108L6.96678 18.5477ZM6.96678 13.4523L6.19586 14.0892L6.19586 14.0892L6.96678 13.4523ZM4.346 1H129V-1H4.346V1ZM132 4V28H134V4H132ZM129 31H4.34601V33H129V31ZM2.03323 26.0892L7.73771 19.1846L6.19586 17.9108L0.491381 24.8154L2.03323 26.0892ZM7.73771 19.1846C9.26488 17.3362 9.26488 14.6638 7.73771 12.8154L6.19586 14.0892C7.11217 15.1983 7.11216 16.8017 6.19586 17.9108L7.73771 19.1846ZM7.73771 12.8154L2.03322 5.91078L0.491377 7.18463L6.19586 14.0892L7.73771 12.8154ZM4.34601 31C1.80843 31 0.416981 28.0455 2.03323 26.0892L0.491381 24.8154C-2.20237 28.0758 0.116724 33 4.34601 33V31ZM132 28C132 29.6569 130.657 31 129 31V33C131.761 33 134 30.7614 134 28H132ZM129 1C130.657 1 132 2.34315 132 4H134C134 1.23857 131.761 -1 129 -1V1ZM4.346 -1C0.11671 -1 -2.20238 3.92417 0.491377 7.18463L2.03322 5.91078C0.416975 3.95451 1.80842 1 4.346 1V-1Z",
    fill: "#003636",
    mask: "url(#path-1-inside-1_959_2692)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusLastStepActive);
export default __webpack_public_path__ + "static/media/status-last-step-active.0eb958e0d6f451e3488b41613b94ffa0.svg";
export { ForwardRef as ReactComponent };